// extracted by mini-css-extract-plugin
export default {"SocialNav":"SocialNav_SocialNav__xoUIK","links":"SocialNav_links__16iZU","Footer":"SocialNav_Footer__Ib-vI"};